import { ArrayHelpers, DomHelpers, SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { customText, hasModule } from 'helpers/profile';
import { getPermissions } from 'helpers/permissions';

import './menu.css';

export const UserMenu = ({ user, profile, history, hide, small, label }) => {
    const [showCardMenu, setShowCardMenu] = React.useState(false);
    const [permissions, setPermissions] = React.useState(getPermissions());
    const { coaching, downline } = useSelector(state => state.user);
    const outer = React.useRef(null);

    React.useEffect(() => {
        if (profile?.id && user?.id) {
            setPermissions(getPermissions(profile, user, coaching, downline));
        }
    }, [profile?.id, user?.id]);

    const handleNavigation = React.useCallback(e => {
        const btn = DomHelpers.getEventButton(e);
        history.push(btn.value);
    });

    const toggle = React.useCallback(() => {
        if (showCardMenu) {
            setShowCardMenu(false);
            document.removeEventListener('click', handleClick, false);
        } else {
            setShowCardMenu(true);
            document.addEventListener('click', handleClick, false);
        }
    });

    const handleClick = e => {
        if (outer.current && !outer.current.contains(e.target)) {
            setShowCardMenu(false);
        }
    };

    const hasIntegration = (user, ref) => {
        return user?.integrations && user.integrations.some(i => i.ref === ref);
    };

    const id = profile?.id || 0;

    const isAdmin = user?.administrator;
    const isManager = downline?.find(d => d.id === profile?.id);

    if (!isAdmin && !isManager && !ArrayHelpers.existsAndHasLength(coaching)) return null;

    return (
        <div className="widget-user-username">
            <div ref={outer} className={showCardMenu ? 'btn-group pull-right open' : 'btn-group pull-right'}>
                <button
                    data-testid="user-menu-button"
                    className={`btn btn-primary dropdown-toggle ${small ? 'btn-xs' : ''}`}
                    onClick={toggle}
                >
                    <i className="fa fa-bars mr10" />
                    {label || SystemText('General/Controls/QuickJump/Label')}
                </button>
                <ul className="dropdown-menu user-menu">
                    {hasModule(user, 'objectives') && permissions.objectives.canView && (
                        <li className={hide === 'objectives' ? 'disabled' : ''}>
                            <button
                                disabled={hide === 'objectives'}
                                className="btn-link"
                                value={`/objectives/${id}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-calendar-check" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/Objectives')}</span>
                            </button>
                        </li>
                    )}
                    {permissions.one2ones.canView && (
                        <li className={hide === '1-2-1s' ? 'disabled' : ''}>
                            <button
                                disabled={hide === '1-2-1s'}
                                className="btn-link"
                                value={`/develop/performance-dashboard/${id}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-line-chart" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/1-2-1s')}</span>
                            </button>
                        </li>
                    )}
                    {(hasIntegration(user, 'ACCELERATE') || hasIntegration(user, 'LEARN2')) && (
                        <li className={hide === 'learning' ? 'disabled' : ''}>
                            <button
                                disabled={hide === 'learning'}
                                className="btn-link"
                                value={`/develop/learning/${id}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-graduation-cap" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/Learning')}</span>
                            </button>
                        </li>
                    )}
                    {permissions.reviews.canView && (
                        <li className={hide === 'appraisals' ? 'disabled' : ''}>
                            <button
                                disabled={hide === 'appraisals'}
                                className="btn-link"
                                value={`/develop/reviews/${id}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-universal-access" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/Reviews')}</span>
                            </button>
                        </li>
                    )}
                    {hasModule(user, 'blogs') && (
                        <li className={hide === 'blogs' ? 'disabled' : ''}>
                            <button
                                disabled={hide === 'blogs'}
                                className="btn-link"
                                value={`/blog/${id}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-comment" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/Blog')}</span>
                            </button>
                        </li>
                    )}
                    {hasModule(user, 'pathways') && permissions.pathways.canView && (
                        <li className={hide === 'pathways' ? 'disabled' : ''}>
                            <button
                                disabled={hide === 'pathways'}
                                className="btn-link"
                                value={`/develop/pathways/${id}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-person-hiking" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/Pathways')}</span>
                            </button>
                        </li>
                    )}
                    {profile?.staff > 0 && (
                        <li className={hide === 'team' ? 'disabled' : ''}>
                            <button
                                disabled={hide === 'team'}
                                className="btn-link"
                                value={`/search?manager=${id}&name=${profile.full_Name}`}
                                onClick={handleNavigation}
                            >
                                <span>
                                    <i className="fa fa-users" />
                                </span>
                                <span>{SystemText('General/Controls/QuickJump/Options/Team')}</span>
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default withRouter(UserMenu);
